<template>
  <div class="page-wrapper home-page">
    <AppHeader />

    <main class="page-main">
      <section class="hero-section">
        <div class="hero-bg"></div>
        <div class=" hero-content home-container">
          <p class="hero-subtitle">Uni Link International Freight</p>
          <h1 class="hero-title">
            Professional Freight Forwarding<br />
            Connecting Every Corner of the World
          </h1>
          <p class="hero-desc">
            Years of expertise in global logistics — trusted freight solutions for thousands of shippers worldwide.
          </p>
          <div class="hero-actions">
            <el-button class="quote-btn" native-type="button" round @click="goQuote">Get a Quote</el-button>
            <el-button class="learn-btn" native-type="button" round @click="goAbout">Learn More <i
                class="el-icon-arrow-right"></i></el-button>
          </div>
        </div>
      </section>

      <section class="service-cards">
        <div class="container">
          <div class="service-card dark" @click="goQuote">
            <div class="card-icon"><img src="/images/icon-search.png" alt="quote" /></div>
            <div class="card-info">
              <h3>Freight Quote</h3>
              <p>Select origin and destination ports to get instant sea/air freight quotes</p>
            </div>
            <img src="/images/icon-arrow-right.png" class="card-arrow" alt="arrow" />
          </div>
          <router-link to="/tracking" class="service-card light">
            <div class="card-icon"><img src="/images/icon-package.png" alt="track" /></div>
            <div class="card-info">
              <h3>Track & Trace</h3>
              <p>Enter the shipping mark number to track shipment status and travel history</p>
            </div>
            <img src="/images/icon-arrow-right.png" class="card-arrow" alt="arrow" />
          </router-link>
        </div>
      </section>

      <section class="why-section">
        <div class="container">
          <h2 class="section-title">Why Choose Uni Link</h2>
          <p class="section-subtitle">
            With years of experience in international freight, we deliver reliable logistics services to<br />
            thousands of Chinese-speaking shippers
          </p>

          <div class="feature-grid">
            <div class="feature-card" v-for="(item, index) in features" :key="index">
              <div class="feature-icon">
                <img :src="item.image" :alt="item.title" />
              </div>
              <h4>{{ item.title }}</h4>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </section>
    </main>

    <AppFooter />
    <OnlineService />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import OnlineService from '@/components/OnlineService.vue'

export default {
  name: 'HomeView',
  components: { AppHeader, AppFooter, OnlineService },
  methods: {
    goQuote() {
      this.$router.push('/freight-calculator')
    },
    goAbout() {
      this.$router.push('/about')
    },
    async fetchFeatures() {
      try {
        const res = await this.$api.getHomecard({})
        this.features = res.data || []
      } catch (e) {
        console.error('getHomecard failed', e)
      }
    }
  },
  data() {
    return {
      features: []
    }
  },
  created() {
    this.fetchFeatures()
  }
}
</script>

<style lang="scss" scoped>
.home-page {}

.home-container {
  padding: 0 0 0 260px;
}

.hero-section {
  position: relative;
  height: 580px;
  display: flex;
  align-items: center;
  color: #fff;
  margin-top: 0;

  .hero-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background:
      url('~@/../public/images/hero-bg.png') center/cover no-repeat;
  }
}

.hero-content {
  position: relative;
  z-index: 1;
  // padding-top: 80px;
}

.hero-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 16px;
}

.hero-title {
  font-size: 48px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 20px;
  max-width: 700px;
}

.hero-desc {
  font-size: 16px;
  opacity: 0.85;
  margin-bottom: 32px;
  max-width: 560px;
}

.hero-actions {
  display: flex;
  gap: 16px;

  .quote-btn {
    background: #fff;
    color: #2e3a8f;
    border-color: #fff;
    padding: 14px 28px;
    font-size: 15px;

    &:hover {
      background: #f5f7fa;
    }
  }

  .learn-btn {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.3);
    padding: 14px 28px;
    font-size: 15px;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  }
}

.service-cards {
  margin-top: -60px;
  position: relative;
  z-index: 2;

  .container {
    display: flex;
    gap: 24px;
  }
}

.service-card {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 40px;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-4px);
  }

  &.dark {
    background: #2e3a8f;
    color: #fff;

    .card-icon {
      background: rgba(255, 255, 255, 0.15);

    }
  }

  &.light {
    background: #409eff;
    color: #fff;

    .card-icon {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .card-icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;

    img {
      width: 72px;
      height: 72px;
      object-fit: contain;
    }
  }

  .card-info {
    flex: 1;

    h3 {
      font-size: 18px;
      margin-bottom: 6px;
    }

    p {
      font-size: 13px;
      opacity: 0.9;
      line-height: 1.5;
    }
  }

  .card-arrow {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}

.why-section {
  padding: 80px 0;

  .section-title {
    text-align: center;
    font-size: 32px;
    color: #333;
    margin-bottom: 12px;
  }

  .section-subtitle {
    text-align: center;
    font-size: 15px;
    color: #666;
    margin-bottom: 50px;
    line-height: 1.8;
  }
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-4px);
  }

  .feature-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 48px;
      height: 48px;
      object-fit: contain;
    }
  }

  h4 {
    font-size: 16px;
    margin-bottom: 8px;
    color: #333;
  }

  p {
    font-size: 13px;
    color: #666;
    line-height: 1.7;
  }
}

@media (max-width: 1200px) {
  .home-container {
    padding-left: 120px;
  }
}

@media (max-width: 992px) {
  .home-container {
    padding-left: 60px;
  }

  .hero-title {
    font-size: 38px;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding-left: 0;
  }

  .hero-section {
    height: auto;
    min-height: 420px;
    padding: 100px 0 90px;

    .hero-bg {
      background-position: 70% center;
    }
  }

  .hero-subtitle {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .hero-title {
    font-size: 26px;
    line-height: 1.3;
    margin-bottom: 14px;

    br {
      display: none;
    }
  }

  .hero-desc {
    font-size: 13px;
    margin-bottom: 24px;
  }

  .hero-actions {
    flex-wrap: wrap;
    gap: 12px;

    .quote-btn,
    .learn-btn {
      padding: 10px 20px;
      font-size: 13px;
    }
  }

  .service-cards {
    margin-top: -40px;

    .container {
      flex-direction: column;
    }
  }

  .service-card {
    padding: 20px;
    gap: 14px;

    .card-icon {
      width: 44px;
      height: 44px;

      img {
        width: 56px;
        height: 56px;
      }
    }

    .card-info {
      h3 {
        font-size: 16px;
      }

      p {
        font-size: 12px;
      }
    }
  }

  .why-section {
    padding: 50px 0;

    .section-title {
      font-size: 24px;
    }

    .section-subtitle {
      font-size: 13px;
      margin-bottom: 32px;

      br {
        display: none;
      }
    }
  }

  .feature-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .feature-card {
    padding: 24px;
  }
}
</style>
